import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import VueI18n from 'vue-i18n'

import Home from '@/components/frontend/home/home'
import Books from '@/components/frontend/books/books'
import BookSub from '@/components/frontend/booksub/booksub'
import Cart from '@/components/frontend/cart/cart'
import OrderData from '@/components/frontend/order/data'
import OrderPayment from '@/components/frontend/order/payment'
import OrderSuccess from '@/components/frontend/order/success'
import OrderError from '@/components/frontend/order/error'
import BookSearch from '../components/frontend/search/BookSearch'

Vue.use(VueRouter)
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: store.state.loading.language, // set locale
  fallbackLocale: 'hu',
  silentTranslationWarn: true,
  messages: {
    en: store.state.loading.languages.en,
    hu: store.state.loading.languages.hu
  } // set locale messages
})
Vue.prototype.$translate = i18n
let router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    component: Home,
    meta: {
      requiresAuth: false,
      title: 'Főoldal'
    }
  },
  {
    path: '/konyvek/:categorySlug?',
    component: Books,
    meta: {
      requiresAuth: false,
      title: 'Könyvek'
    }
  },
  {
    path: '/kereses/:search',
    component: BookSearch,
    meta: {
      requiresAuth: false,
      title: 'Keresés'
    }
  },
  {
    path: '/kosar',
    component: Cart,
    meta: {
      requiresAuth: false,
      title: 'Kosár'
    }
  },
  {
    path: '/rendeles/adatok',
    component: OrderData,
    meta: {
      requiresAuth: false,
      title: 'Rendelési adatok'
    }
  },
  {
    path: '/rendeles/fizetes',
    component: OrderPayment,
    meta: {
      requiresAuth: false,
      title: 'Fizetési adatok'
    }
  },
  {
    path: '/sikeres-megrendeles',
    component: OrderSuccess,
    meta: {
      requiresAuth: false,
      title: 'Összegzés'
    }
  },
  {
    path: '/megrendeles-hiba',
    component: OrderError,
    meta: {
      requiresAuth: false,
      title: 'Összegzés'
    }
  },
  {
    path: '*',
    redirect: '/',
    meta: {
      requiresAuth: true,
      title: '1000 könyv'
    }
  },
  {
    path: '/:slug',
    component: BookSub,
    meta: {
      requiresAuth: false,
      title: 'Könyvek'
    }
  }
  ]
})
router.beforeEach((to, from, next) => {
  if (store.state.loading.unsaved === true) {
    let r = confirm(i18n.t('Önnek nem mentett változásai vannak! Biztosan kilép az oldalról?'))
    if (r === true) {
      store.commit('loading/changeUnsaved', false)
    } else {
      return false
    }
  }
  store.commit('loading/change', true)
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title + ' | ' + process.env.APP_NAME
  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))
  // Skip rendering meta tags if there are none.
  if (nearestWithMeta) {
    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta')
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })
      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')
      return tag
    })
    // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag))
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (localStorage.getItem('token') === null) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js